// extracted by mini-css-extract-plugin
export var container = "Team-module--container--316b6";
export var layout = "Team-module--layout--09c78";
export var sliderWrapper = "Team-module--sliderWrapper--60e48";
export var slide = "Team-module--slide--c79ff";
export var alert = "Team-module--alert--2f70a";
export var alertText = "Team-module--alertText--4d0a0";
export var alertButton = "Team-module--alertButton--28fbd";